module.exports = "/_next/static/images/logo-tecprotec-fea7fe362ab6497fabf9b003db72a826.svg";